import { Injectable } from "@angular/core";
import { collection, collectionSnapshots, Firestore, orderBy, query, QueryDocumentSnapshot, where } from "@angular/fire/firestore";
import { Data, Router } from "@angular/router";
import { EMPTY, of } from "rxjs";
import { catchError, map, retry, shareReplay, switchMap, take } from "rxjs/operators";
import { CommonService } from "./common/common.service";

@Injectable({
  providedIn: "root",
})
export class NarratorService {

  constructor(
    private firestore: Firestore,
    private router: Router,
    private commonService: CommonService
  ) { }

  private mapDocumentChangeActionsToData(
    docs: QueryDocumentSnapshot<unknown>[]
  ): Data[] {
    return docs.map((docSnap) => {
      const data = docSnap.data() as Data;
      const id = docSnap.id;
      return { id, ...data };
    });
  }

  // Get Narrator Tips Data
  getNarratorTipsHome() {
    return this.commonService.getUid("NarratorService").pipe(
      take(1),
      switchMap((userId) => {
        if (!userId) return EMPTY;

        const narratorTipsRef = query(
          collection(this.firestore, `users/${userId}/narrator_tips`),
          where('setting.seen', '==', false),
          orderBy('setting.creation_timestamp', 'asc')
        );

        return collectionSnapshots(narratorTipsRef).pipe(
          retry(2),
          catchError((error) => {
            console.error("An error occurred while fetching narrator tips:", error);
            return of([]);
          }),
          map((actions: any[]) => this.mapDocumentChangeActionsToData(actions)),
          shareReplay(1)
        );
      })
    );
  }

  //get current page url
  getCurrentPageURL(): string {
    //get current page url
    const uri = this.router.url;
    const splitURL = uri?.split("/");
    //get last page name from url
    const lastIndex = splitURL[splitURL.length - 1];
    return lastIndex;
  }
}
